import { MdSearch } from "react-icons/md";
import "./adminToolbar.css";

// One toolbar row for list pages - search + filter controls + trailing
// actions. Replaces each page's own .toolbar/.toolbarSearch/.toolbarSort
// classes (previously duplicated, near-identically, in Products/Orders
// and absent everywhere else).
export const AdminToolbar = ({ searchValue, onSearchChange, searchPlaceholder = "Search...", filters, actions }) => (
  <div className="admin-toolbar">
    {onSearchChange && (
      <div className="admin-toolbar__search">
        <MdSearch aria-hidden="true" />
        <input
          type="text"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
          aria-label={searchPlaceholder}
        />
      </div>
    )}
    {filters && <div className="admin-toolbar__filters">{filters}</div>}
    {actions && <div className="admin-toolbar__actions">{actions}</div>}
  </div>
);
